import { render, staticRenderFns } from "./Management-detail.vue?vue&type=template&id=81c53e52&scoped=true&"
import script from "./Management-detail.vue?vue&type=script&lang=js&"
export * from "./Management-detail.vue?vue&type=script&lang=js&"
import style0 from "./Management-detail.vue?vue&type=style&index=0&id=81c53e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c53e52",
  null
  
)

export default component.exports